import { useCallback, useEffect, useRef, useState } from 'react';
import {
  Checkbox,
  FormControlLabel,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { ehandoverAPI } from '../../../../../apis';
import { i18n } from '../../../../../language';
import { getArrayRandomKey } from '../../../../../utils';
import { setEhdSetting } from '../../../../../redux/actions';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#fff',
    padding: '1.875rem',
    borderRadius: '0 0.93rem 0.93rem 0.93rem',
  },
  tableContainer: {
    height: '65vh',
  },
  table: {
    position: 'relative',
    minWidth: '45rem',
    '& .MuiTableCell-root': {
      border: 'none',
      fontSize: '1.125rem',
      fontWeight: '500',
      lineHeight: '1.675rem',
      color: '#2e4469',
      padding: '0 1rem ',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      left: '0',
      zIndex: '10',
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
        textTransform: 'uppercase',
      },
      '& .MuiTableCell-root': {
        fontWeight: 'bold',
        color: '#538fff',
        padding: '1rem',
        backgroundColor: '#fff',
        fontSize: '0.875rem',
      },
      '& .MuiTableCell-root:nth-child(1)': {
        paddingLeft: '1.313rem',
      },
      '& .MuiTableCell-root:nth-last-child(1)': {
        paddingRight: '1.883rem',
      },
    },
    '& .MuiTableBody-root': {
      '& :hover': {
        backgroundColor: '#f5faff',
      },
      '& > .MuiTableRow-root': {
        borderBottom: '1px solid #E6E8E9',
      },
      '& .MuiTableCell-root': {
        height: '3.5rem',
        fontFamily: 'NotoSans-Medium',
      },
      '& .MuiTableCell-root:nth-child(1)': {
        paddingLeft: '1.313rem',
      },
      '& .MuiTableCell-root:nth-last-child(1)': {
        paddingRight: '1.883rem',
      },
    },
  },
  tableHead: {
    whiteSpace: 'nowrap',
  },
  add: {
    width: '5.688rem',
    height: '3rem',
    background: '#538fff',
    color: '#fff',
    borderRadius: '0.625rem',
    fontWeight: '500',
    fontFamily: 'NotoSans-Medium',
  },
  checkBox: {
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
}));

export default function View() {
  const classes = useStyles();
  const [viewList, setViewList] = useState([]);
  const language = useSelector((state) => state.settings.language);
  const ehdSettings = useSelector((state) => state.ehdSetting.setting);
  const loginInfo = useSelector((state) => state.loginInfo);
  const tableRef = useRef();

  const dispatch = useDispatch();

  const getSettingViewList = useEffect(() => {
      
      const list = [
        {
          text: i18n.t('EHANDOVER_SEPEARATE_CHECKLIST'),
          isChecked: ehdSettings?.find(s => s.settingKey === "IS_SEPARATE_CHECKLIST_TAB" )?.settingValue === 'Y',
          type: 'SEPARATE_CHECKLIST_TAB',
          settingKey: "IS_SEPARATE_CHECKLIST_TAB"
        },
        {
          text: i18n.t('EHANDOVER_RELOCATE_PINNED_ITEMS'),
          isChecked: ehdSettings?.find(s => s.settingKey === "IS_RELOCATE_PIN_TAB" )?.settingValue === 'Y',
          type: 'RELOCATE_PIN_TAB',
          settingKey: "IS_RELOCATE_PIN_TAB"
        },
        {
          text: i18n.t('EHANDOVER_DEFAULT_NOT_SEND_TO'),
          isChecked: ehdSettings?.find(s => s.settingKey === "IS_NOT_TO_SEND_AS_DEFAULT" )?.settingValue === 'Y',
          type: 'IS_NOT_TO_SEND_AS_DEFAULT',
          settingKey: "IS_NOT_TO_SEND_AS_DEFAULT"
        },
        {
          text: i18n.t('EHANDOVER_SINK_CHECKLIST_ITEM'),
          isChecked: ehdSettings?.find(s => s.settingKey === "SINK_COMPLELTED_CHECKLIST_ITEM" )?.settingValue === 'Y',
          type: 'SINK_COMPLELTED_CHECKLIST_ITEM',
          settingKey: "SINK_COMPLELTED_CHECKLIST_ITEM"
        },
      ];
      setViewList(list);
    
  }, [ehdSettings]);

  const updateSetting = async (rowItem, isChecked) => {
    try {
      const newViewList = _.map(viewList, (item) => ({
        ...item,
        isChecked: item.type === rowItem.type ? isChecked : item.isChecked,
      }));
      await ehandoverAPI.upsertSetting({
        settingKey: rowItem.settingKey,
        settingValue: isChecked ? 'Y' : 'N',
        isEnable: 'Y' ,
      });
      
      setViewList(newViewList);
    } catch (error) {

    }
  };

  useEffect(async () => {
    const { result } = await ehandoverAPI.getSettingList({wardId: loginInfo?.wardId ?? 0});
    dispatch(setEhdSetting(result));
  }, [language, loginInfo?.wardId]);

  return (
    <div className={classes.root}>
      <TableContainer className={classes.tableContainer} ref={tableRef}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.tableHead} id="bed_setting_table_head">
            <TableRow>
              <TableCell align="left" style={{ wordBreak: 'break-all' }}>
                {i18n.t('EHANDOVER_VIEW')}
              </TableCell>
              <TableCell align="center">{i18n.t('BEDSTATUS_ACTIVE')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody id="bed_setting_table_body">
            {viewList.map((row, rowIndex) => {
              return (
                <TableRow
                  key={getArrayRandomKey(rowIndex, 'ehandover-access-control')}
                  id={`e_handover_setting_table_row${rowIndex}`}
                >
                  <TableCell align="left">{row?.text}</TableCell>
                  <TableCell align="center">
                    <FormControlLabel
                      id="edit_access_control_checkbox"
                      control={<Checkbox />}
                      label=""
                      className={classes.checkBox}
                      checked={row?.isChecked}
                      onChange={(event) => updateSetting(row, event.target.checked)}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
